import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes} from "../common/enums/ExcelEnum";

const logPrefix  = "[EvenStepThreeStore]"
export default class EvenStepThreeStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.notMatchCount = 3;
        this.contentTapIndex = 0;
        this.contentList = [];
        this.matchQuizzes = [];
        this.selectedContent = [];
        this.readyToSaveStep = false;
        this.stepValue = 0;
        this.dayValue = 0;

        makeAutoObservable(this);
    }

    initEvenStepThreeContent = () => {
        this.contentList = [];
        this.matchQuizzes = [];
        this.notMatchCount = 3;
        this.selectedContent = [];
        this.contentTapIndex = 0;
        this.translationContents = {};
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }


    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode());
        this.setMatchQuizzes();
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    getRandomNumbers = (min, max, count) => {
        const numbers = Array.from({ length: max - min + 1 }, (_, i) => i + min);
        const randomNumbers = [];
        while (randomNumbers.length < count && numbers.length > 0) {
            const randomIndex = Math.floor(Math.random() * numbers.length);
            randomNumbers.push(numbers.splice(randomIndex, 1)[0]);
        }
        return randomNumbers;
    }

    setMatchQuizzes = () => {
        this.matchQuizzes = this.selectedContent.filter(content => content.keyword).map(c => c.leftWord);
        this.notMatchCount = this.matchQuizzes.length;
        if (!this.matchQuizzes.length) {
            this.notMatchCount = 3;
        }
    }

    setKeyword = (value, index) => {
        this.matchQuizzes[index] = value;
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setWord = (value, index, direction) => {
        const reorderedContents = Array.from(this.selectedContent);
        reorderedContents[index][direction] = value;
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode);
    }

    setGenerateWords = (words) => {
        this.matchQuizzes = [];
        words.forEach(word => {
            this.matchQuizzes.push(word);
        });
    }

    setGenerateQuizzes = (quizzes) => {
        const reorderedContents = Array.from(this.selectedContent);
        quizzes.forEach((quiz, i) => {
            reorderedContents[i].leftWord = quiz;
            reorderedContents[i].rightWord = quiz;
            reorderedContents[i].keyword = false;
        });

        const randomNumbers = this.getRandomNumbers(0, reorderedContents.length-1, this.notMatchCount);

        this.matchQuizzes.forEach((keyword, i) => {
            reorderedContents[randomNumbers[i]].leftWord = keyword;
            reorderedContents[randomNumbers[i]].keyword = true;
        });

        this.setReorderedContents(reorderedContents, this.getSelectedLangCode);
    }

    setReorderedContents = (contents, langeCode) => {
        this.contentList.filter(content => content.languageCode === langeCode).contents = contents;
        this.contentStore.setReadyToSaveStep(this.isThreeStepPartCompleted());
        this.readyToSaveStep = this.isThreeStepPartCompleted();
    }

    setNotMatchCount = (value) => {
        this.notMatchCount = value;
        if (this.matchQuizzes.length > this.notMatchCount) {
            const splitCount = this.matchQuizzes.length - this.notMatchCount;
            if (splitCount > 0) {
                this.matchQuizzes.splice(-splitCount, splitCount);
            }
        } else if (this.matchQuizzes.length < this.notMatchCount) {
            const addCount = this.notMatchCount - this.matchQuizzes.length;
            for (let i = 0; i < addCount; i++) {
                this.matchQuizzes.push("");
            }
        }
    }

    convertDefaultQuizzesForm = (data) => {
        for (let lang = 0; lang < 4; lang++) {
            const langContents = data.filter(content => content.languageCode === langTypes[lang]);
            Array.from({ length: 9 }, (_, i) => langContents[i] || { leftWord: '', rightWord: '', keyword: false, languageCode: langTypes[lang]}).forEach(content => {
                this.contentList.push(content);
            });
        }
    }

    isThreeStepPartCompleted = () => {
        let hasEmptyValues = false;
        if (this.contentList.some(content => (!!content.leftWord && !content.rightWord) || (!content.leftWord && !!content.rightWord))) {
            hasEmptyValues = true;
        }
        return !hasEmptyValues;
    }

    isThreeStepCompleted = () => {
        let hasEmptyValues = false;
        if (this.contentList.some(content => !content.leftWord || !content.rightWord)) {
            hasEmptyValues = true;
        }
        console.log(hasEmptyValues);
        return !hasEmptyValues;
    }

    * getEvenStepThreeContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepThreeContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/3`;
            const response = yield this.contentRepository.getContent(url);
            this.convertDefaultQuizzesForm(response.data);
            this.contentStore.setReadyToMoveExit(this.isThreeStepPartCompleted() && this.isThreeStepCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            this.setSelectedContent();
            console.log(logPrefix, 'Finished getEvenStepThreeContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepThreeContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepThreeContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepThreeContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/3`;
            console.log(logPrefix, 'modifyEvenStepThreeContent requestContents :', this.contentList);
            yield this.contentRepository.putContent(url, this.contentList);
            console.log(logPrefix, 'Finished modifyEvenStepThreeContent.');
            this.contentStore.setReadyToSaveStep(false);
            this.contentStore.setReadyToMoveExit(this.isThreeStepPartCompleted() && this.isThreeStepCompleted());
            this.readyToSaveStep = false;
        } catch (e) {
            console.log(logPrefix, 'Failed modifyEvenStepThreeContent.');
            this.openErrorDialog({
                titleText: '대화문 번역 수정 오류',
                text: displayErrorDialogPrompt(e, '대화문 번역 수정 작업중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

}

